const backendUrl = 'https://task-man-server.vercel.app';

export default backendUrl;
